import { UserCategoryViewModel, UserDetailsViewModel, CategoryViewModel } from "../../configuration/api/apiSchema";
import { updateObject } from "../../helpers/updateObject";
import { GET_USER_CATEGORIES, SELECT_USER_CATEGORIES, UPDATE_USER_CATEGORY_RATE, GET_ALL_CATEGORIES, ADD_USER_CATEGORIES, REMOVE_USER_CATEGORIES } from "./actions";

export type CategoryState = {
    isLoading: boolean;
    isError: boolean;
    isCategoriesSelectedAndSaved: boolean;
    isCategoryRateUpdated: boolean;
    userCategories?: UserCategoryViewModel[];
    allCategories?: CategoryViewModel[];
    isAddingCategories?: boolean;
    isRemovingCategories?: boolean;
}

const initialState = {
    isLoading: false,
    isError: false,
    isCategoriesSelectedAndSaved: false,
    isCategoryRateUpdated: false,
    userCategories: undefined,
    allCategories: undefined,
    isAddingCategories: false,
    isRemovingCategories: false,
};

const updateUserCategoriesWithNewValue = (
    userCategories: UserCategoryViewModel[],
    updatedUserCategory: UserCategoryViewModel
): UserCategoryViewModel[] | undefined => {
    if (!userCategories) {
        return;
    }

    const userCategoriesCopy = [...userCategories];
    const index = userCategoriesCopy.findIndex((category) => category.id === updatedUserCategory.id);

    if (index !== -1) {
        // Update the existing category
        userCategoriesCopy[index] = updatedUserCategory;
    } else {
        // Add the new category if it doesn't exist
        userCategoriesCopy.push(updatedUserCategory);
    }

    return userCategoriesCopy;
};


export const reducer = (state: CategoryState = initialState, action: any) => {
    switch (action.type) {
        case SELECT_USER_CATEGORIES.REQUEST:
            return updateObject(state, { isLoading: true, isError: false, isCategoriesSelectedAndSaved: false });
        case SELECT_USER_CATEGORIES.SUCCESS:
            return updateObject(state, { isLoading: false, isCategoriesSelectedAndSaved: true });
        case GET_USER_CATEGORIES.REQUEST:
            return updateObject(state, { isLoading: true, isError: false, userCategories: undefined });
        case GET_USER_CATEGORIES.SUCCESS:
            return updateObject(state, { isLoading: false, userCategories: action.userCategories });
        case UPDATE_USER_CATEGORY_RATE.REQUEST:
            return updateObject(state, {  isError: false, isCategoryRateUpdated: false });
        case UPDATE_USER_CATEGORY_RATE.SUCCESS:
            return updateObject(state, { isCategoryRateUpdated: true, userCategories: updateUserCategoriesWithNewValue(state.userCategories as any, action.updatedUserCategory) });
        
        // Get all categories
        case GET_ALL_CATEGORIES.REQUEST:
            return updateObject(state, { isLoading: true, isError: false });
        case GET_ALL_CATEGORIES.SUCCESS:
            return updateObject(state, { isLoading: false, allCategories: action.categories });
        case GET_ALL_CATEGORIES.FAILURE:
            return updateObject(state, { isLoading: false, isError: true });
        
        // Add user categories
        case ADD_USER_CATEGORIES.REQUEST:
            return updateObject(state, { isAddingCategories: true, isError: false });
        case ADD_USER_CATEGORIES.SUCCESS:
            return updateObject(state, { isAddingCategories: false });
        case ADD_USER_CATEGORIES.FAILURE:
            return updateObject(state, { isAddingCategories: false, isError: true });
        
        // Remove user categories
        case REMOVE_USER_CATEGORIES.REQUEST:
            return updateObject(state, { isRemovingCategories: true, isError: false });
        case REMOVE_USER_CATEGORIES.SUCCESS:
            return updateObject(state, { isRemovingCategories: false });
        case REMOVE_USER_CATEGORIES.FAILURE:
            return updateObject(state, { isRemovingCategories: false, isError: true });

        default:
            return state;
    }
};